import React, { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  useGetPrevCustElemById,
  useUpdatePrevCustElem,
  validationSchemaPrevCustElem,
} from './ServicesCE';

import { FormField } from '../../common/FormField';

import { useFieldsPrevCustElem1 } from './FormPreventivi';
import { useFieldsPrevCustElem2 } from './FormPreventivi';
import { useFieldsPrevCustElem3 } from './FormPreventivi';
import { useFieldsPrevCustElem4 } from './FormPreventivi';
import { useFieldsPrevCustElem5 } from './FormPreventivi';

import { PrevCustElem } from './types';

interface PreventiviEditCEROWProps {
  open: boolean;
  onClose: () => void;
  idprevcustelemprop: number; // ✅ FIXED TYPE
}

const PreventiviEditCEROW: React.FC<PreventiviEditCEROWProps> = ({
  open,
  onClose,
  idprevcustelemprop,
}) => {
  /* ================= FORM ================= */
  const {
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm<PrevCustElem>({
    resolver: yupResolver(validationSchemaPrevCustElem),
  });


const numanalisi = watch('numanalisi');
const numconf = watch('numconf');
const numform = watch('numform');
const numprep = watch('numprep');


  /* ================= FIELDS ================= */
  const fieldsPrevCustElem1 = useFieldsPrevCustElem1();
  const fieldsPrevCustElem2 = useFieldsPrevCustElem2();
  const fieldsPrevCustElem3 = useFieldsPrevCustElem3();
  const fieldsPrevCustElem4 = useFieldsPrevCustElem4();
  const fieldsPrevCustElem5 = useFieldsPrevCustElem5();

  /* ================= DATA ================= */
  const { data } =
    useGetPrevCustElemById(idprevcustelemprop);

  const prevcustelem = data?.results?.[0];


  useEffect(() => {
  const total =
    (Number(numanalisi) || 0) +
    (Number(numconf) || 0) +
    (Number(numform) || 0) +
    (Number(numprep) || 0);

  setValue('numtot', total, { shouldValidate: true });
}, [numanalisi, numconf, numform, numprep, setValue]);


  /* ================= INIT ================= */
 useEffect(() => {
  if (prevcustelem) {
    reset(prevcustelem);
  }
}, [prevcustelem, reset]);

  /* ================= MUTATION ================= */
  const { mutateAsync: updatePrevCustElem, isPending } =
    useUpdatePrevCustElem();

  /* ================= SUBMIT ================= */
  const onSubmit: SubmitHandler<PrevCustElem> = async data => {
    await updatePrevCustElem(data);
    onClose();
  };

  /* ================= UI ================= */
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>
        <Typography variant="h6">Modifica Riga Preventivo</Typography>
      </DialogTitle>

      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={2}>
            <Stack direction="row" spacing={2}>
            {fieldsPrevCustElem1.map(f => (
              <FormField
                key={String(f.name)}
                control={control}
                field={f}
              />
            ))}
            </Stack>
           <Stack direction="row"  spacing={2}>
          {fieldsPrevCustElem2.map(f => (  <FormField  key={String(f.name)} control={control} field={f} /> ))}
           </Stack>
           <Stack direction="row"  spacing={2}>
          {fieldsPrevCustElem3.map(f => (  <FormField  key={String(f.name)} control={control} field={f} /> ))}
           </Stack>
           <Stack direction="row"  spacing={2}>
          {fieldsPrevCustElem4.map(f => (  <FormField  key={String(f.name)} control={control} field={f} /> ))}
           </Stack>
           <Stack direction="row"  spacing={2}>
          {fieldsPrevCustElem5.map(f => (  <FormField  key={String(f.name)} control={control} field={f} /> ))}
           </Stack>


            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button onClick={onClose} color="error">
                Annulla
              </Button>
              <Button type="submit" variant="contained" disabled={isPending}>
                {isPending ? 'Salvando…' : 'Salva'}
              </Button>
            </Stack>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default PreventiviEditCEROW;
